import { render, staticRenderFns } from "./Ionicons.vue?vue&type=template&id=00e66b07&"
import script from "./Ionicons.vue?vue&type=script&lang=js&"
export * from "./Ionicons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports